// External Dependencies:
import Cookie from 'js-cookie'

export function getUserPreferredLocale( availableLocales, defaultLocale ) {
	const cookieLocale = Cookie.get( 'locale' )

	const locale =
		[
			cookieLocale,
			...( window.navigator.languages || [] ),
			window.navigator.language,
			window.navigator.browserLanguage,
			window.navigator.userLanguage,
			window.navigator.systemLanguage
		]
		.filter( Boolean )
		.map( language => language.substr( 0, 2 ) )
		.find( language => availableLocales.includes( language ) ) || defaultLocale

	return locale
}
